import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { I18nModule } from '../../../../core/i18n';
import { DropdownModule } from '../../../../shared';
import { PickerAttributeComponent } from './picker-attribute.component';

@NgModule({
  imports: [CommonModule, I18nModule, FormsModule, DropdownModule, ReactiveFormsModule],
  declarations: [PickerAttributeComponent],
  exports: [PickerAttributeComponent],
})
export class PickerAttributeModule {}
